export enum ChannelOrderPrefix {
	NKON = 'NKON',
	MFCN = 'MFCN',
}
